module.exports = __webpack_public_path__ + "img/Estuche de 1 L.33cce05f.jpg";